import { Form } from 'components/Wizards/Form/Form'
import { useField } from 'formik'
import FormStyles from 'components/Wizards/Wizard/Form/Sections.module.scss'
import { Field as BaseField } from 'components/Wizards/Field/Field'
import { Button } from 'blaze-ui/Button/Button'
import { SnippetTypeaheadInput } from 'components/Wizards/Wizard/Form/SnippetTypeaheadInput'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Paragraph } from 'blaze-ui/Paragraph/Paragraph'
import { Edit3 } from 'blaze-ui/icons'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'

interface Props {
  isTopicSet: boolean
  setIsTopicSet: (val: boolean) => void
  topicField: FieldSchema
}

export const MobileTopic = ({ isTopicSet, setIsTopicSet, topicField }: Props) => {
  const [topic, ,] = useField('topic')
  const schema = topicField.describe()
  const { nullable, optional, meta } = schema
  const isRequired = !nullable && !optional

  const resetTopic = () => {
    setIsTopicSet(false)
  }

  return (
    <>
      {isTopicSet && (
        <Form.Section backgroundColor="var(--light-40)">
          <div className={FormStyles.completedContent}>
            <Heading level={5}>Scene Description</Heading>
            <Paragraph variant="secondary" color="var(--dark-80)">
              {topic.value}
            </Paragraph>
            <div className={FormStyles.editButtonContainer}>
              <Button onPress={resetTopic} variant="ghost" frontIcon={Edit3} size="sm">
                Edit
              </Button>
            </div>
          </div>
        </Form.Section>
      )}
      {!isTopicSet && (
        <Form.Section backgroundColor="var(--light-60)">
          <Form.SectionContent>
            <BaseField name="topic" label={meta.label} direction="column" isRequired={isRequired}>
              <SnippetTypeaheadInput
                name="topic"
                schema={topicField}
                autoFocus
                actionOnPress={() => setIsTopicSet(true)}
                actionDisabled={!topic.value}
              />
            </BaseField>
          </Form.SectionContent>
        </Form.Section>
      )}
    </>
  )
}
